import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function TerrifPlan() {
    const plans = [
      {
        roomType: '1 Sharing Room',
        price: 'Rs.8500.00',
        deposit: 'Rs.3000.00',
        food: 'Including Breakfast & Dinner',
        foodTimes: 'Breakfast: 8:00 am to 9:00 am, Dinner: 8:00 pm to 9:00 pm',
      },
      {
        roomType: '2 Sharing Room',
        price: 'Rs.7000.00',
        deposit: 'Rs.3000.00',
        food: 'Including Breakfast & Dinner',
        foodTimes: 'Breakfast: 8:00 am to 9:00 am, Dinner: 8:00 pm to 9:00 pm',
      },
      {
        roomType: '3 Sharing Room',
        price: 'Rs.6000.00',
        deposit: 'Rs.3000.00',
        food: 'Including Breakfast & Dinner',
        foodTimes: 'Breakfast: 8:00 am to 9:00 am, Dinner: 8:00 pm to 9:00 pm',
      },
    ];
  
    return (
      <>

<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 | Om Sai PG| Teriff Plan|  Girls Hostels in Kharadi | Boys Hostel in Kharadi | Monthly Basis PG in Kharadi| PG in Wagholi
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG in Pune, Girls Hostels in Kharadi, Boys Hostel in Kharadi, Monthly Basis PG in Kharadi,
PG in Wagholi"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

        <section className="section-breadcrumb padding-b-50">
          <div className="rx-breadcrumb-image bg-img">
            <div className="rx-breadcrumb-overlay"></div>
            <div className="inner-breadcrumb-contact">
              <div className="main-breadcrumb-contact">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="rx-banner-contact">
                        <h2>Tariff Plans</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rx-banner-breadcrumb">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="breadcrumb-contact">
                        <div className="main-heading">
                          <h4>Tariff Plans</h4>
                        </div>
                        <div className="last-contact">
                          <ul>
                            <li>
                              <Link to="/">Home</Link>
                            </li>
                            <li>Tariff Plans</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  
        <div className="tariff-plan-section">
          <h2>Tariff Plan of "Om Sai PG"</h2>
          <div className="tariff-cards">
            {plans.map((plan, index) => (
              <div key={index} className="tariff-card">
                <h3>{plan.roomType}</h3>
                <p className="price">{plan.price}</p>
                <p>{plan.food}</p>
                <p>
                  <strong>Deposit:</strong> {plan.deposit}
                </p>
                <p>
                  <strong>Food Timings:</strong> {plan.foodTimes}
                </p>
                <button className="book-now-btn"><Link to='https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking a room at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!!' className="text-white" target="_blank">Book Now</Link> </button>
              </div>
            ))}
          </div>
          <div className="contact-info">
            <p>
              <strong>Contact Numbers:</strong> <a href="tel:+91 9763888448" className="fs-4 text-purple">+91 9763888448</a>  <a href="tel:+91 9922248255" className="fs-3 text-purple">+91 9922248255</a> 
            </p>
          </div>
        </div>
      </>
    );
  }
  